module.exports = __webpack_public_path__ + "img/pic_200378_2.53ab5fb1.jpg";